import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black-light border-t border-gray-800 mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <h3 className="heading-metallic-soft text-2xl mb-4">TABRAM EYEWEAR</h3>
            <p className="text-gray-400 text-sm">Supplying independent opticians across Ireland & the UK</p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-gold-500 text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-gold-500 text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-gold-500 text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/after-sale" className="text-gray-400 hover:text-gold-500 text-sm">
                  After Sale
                </Link>
              </li>
            </ul>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Shop</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/optical" className="text-gray-400 hover:text-gold-500 text-sm">
                  Optical Frames
                </Link>
              </li>
              <li>
                <Link to="/sunglasses" className="text-gray-400 hover:text-gold-500 text-sm">
                  Sunglasses
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-gold-500 text-sm">
                  Become a Trade Customer
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Email: trade@tabrameyewear.ie</li>
              <li>Phone: +353 83 044 2498</li>
              <li>Mon-Fri: 9:00 AM - 5:00 PM</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {currentYear} TABRAMEYEWEAR. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
